import { render, staticRenderFns } from "./seekHouseCollection.vue?vue&type=template&id=6989ba54&scoped=true&"
import script from "./seekHouseCollection.vue?vue&type=script&lang=js&"
export * from "./seekHouseCollection.vue?vue&type=script&lang=js&"
import style0 from "./seekHouseCollection.vue?vue&type=style&index=0&id=6989ba54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6989ba54",
  null
  
)

export default component.exports